import React from 'react'
import { Link } from 'react-router-dom'

const IconLink = ({ className, to, image, title, ringClass }) => (
    <Link className={className} to={to}>
        <div className="icon-link">
            <img className={'icon-link-image ' + ringClass} src={image} />
            <span className="icon-link-text mt-3 text-center">{title}</span>
        </div>
    </Link>
)

export default IconLink
